import React, { useState, useEffect, useRef } from 'react'
import { ACTION } from 'consts/index'
import { useDispatch, useSelector } from 'react-redux'
import MapGL, { Marker } from '@goongmaps/goong-map-react'
import { filterOptionSelect, removeAccents } from 'utils'
import { TIME_SLOTS } from 'consts'
//antd
import {
  Input,
  Button,
  Row,
  notification,
  Form,
  Upload,
  Drawer,
  Col,
  Select,
  Space,
  AutoComplete,
  Spin,
  InputNumber,
  Checkbox,
} from 'antd'

//components

//icons
import { LoadingOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons'

//apis
import { addBranch, updateBranch } from 'apis/branch'
import { uploadFile, uploadFilePDF } from 'apis/upload'
import { searchAddress } from 'apis/address'
import { getFileName } from 'utils'
import { InboxOutlined } from '@ant-design/icons'

export default function BranchForm({ reloadData, children, infoBranch, regions = [] }) {
  const typingTimeoutRef = useRef(null)
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const dataUser = useSelector((state) => state.navigation)

  const [filesView, setFilesView] = useState([])
  const [loadingFile, setLoadingFile] = useState(false)
  const [loadingAddress, setLoadingAddress] = useState(false)
  
  const [files, setFiles] = useState([])
  const [addressList, setAddressList] = useState([])
  const [viewport, setViewport] = useState({ latitude: 0, longitude: 0, zoom: 8 })
  const [visible, setVisible] = useState(false)
  const [imageReservation, setImageReservation] = useState('')
  const [loadingReservation, setLoadingReservation] = useState(false)
  const [timeBlocks, setTimeBlocks] = useState(Array(7).fill({
    open: '',
    close: ''
  }))
  const [timeSlots, setTimeSlots] = useState([])
  const [monOpen, setMonOpen] = useState(null)
  const [monClose, setMonClose] = useState(null)
  const [tueOpen, setTueOpen] = useState(null)
  const [tueClose, setTueClose] = useState(null)
  const [wedOpen, setWedOpen] = useState(null)
  const [wedClose, setWedClose] = useState(null)
  const [thuOpen, setThuOpen] = useState(null)
  const [thuClose, setThuClose] = useState(null)
  const [friOpen, setFriOpen] = useState(null)
  const [friClose, setFriClose] = useState(null)
  const [satOpen, setSatOpen] = useState(null)
  const [satClose, setSatClose] = useState(null)
  const [sunOpen, setSunOpen] = useState(null)
  const [sunClose, setSunClose] = useState(null)

  const [imagesParty, setImagesParty] = useState([])
  const [loadingImagesParty, setLoadingImagesParty] = useState(false)
  const [imageBranch, setImageBranch] = useState('')

  const [filesDrink, setFilesDrink] = useState([])
  const [filesFood, setFilesFood] = useState([])
  const [filesWine, setFilesWine] = useState([])
  const [filesNews, setFilesNews] = useState([])
  const [filesFoodPicture, setfilesFoodPicture] = useState([])

  const [filesDrinkView, setFilesDrinkView] = useState([])
  const [filesFoodView, setFilesFoodView] = useState([])
  const [filesWineView, setFilesWineView] = useState([])
  const [filesNewsView, setFilesNewsView] = useState([])
  const [filesFoodPictureView, setFilesFoodPictureView] = useState([])
  
  const _addOrUpdateBranch = async () => {
    try {
      await form.validateFields()
      const formData = form.getFieldsValue()

      if (files.length === 0) {
        notification.warning({ message: 'Vui lòng tải lên ít nhất 1 hình ảnh' })
        return
      }

      const region = regions.find((e) => e.region_id === formData.region_id)

      const body = {
        ...formData,
        image_urls: files || [],
        user_id: dataUser && dataUser.data.user_id,
        country_id: region ? region.country_id : '',
        email: '',
        fax: '',
        ward: '',
        district: '',
        province: '',
        date_open: formData.date_open || '',
        date_close: formData.date_close || '',
        description_reservation: formData.description_reservation || '',
        content_below_map: formData.content_below_map || '',
        images_reservation: imageReservation ? [imageReservation] : [],
        opening_data: timeBlocks,
        is_ATF: formData.is_ATF || false,
        is_ST: formData.is_ST || false,
        image_party: imagesParty,
        filesDrink: filesDrink,
        filesFood: filesFood,
        filesWine: filesWine,
        filesNews: filesNews,
        filesFoodPicture: filesFoodPicture,
      }
      console.log(body)

      dispatch({ type: ACTION.LOADING, data: true })
      let res
      if (infoBranch) res = await updateBranch(infoBranch.branch_id, body)
      else res = await addBranch(body)

      if (res.status === 200) {
        if (res.data.success) {
          notification.success({
            message: `${infoBranch ? 'Cập nhật' : 'Tạo'} chi nhánh thành công`,
          })
          setVisible(false)
          reloadData()
        } else
          notification.error({
            message:
              res.data.message ||
              `${infoBranch ? 'Cập nhật' : 'Tạo'} chi nhánh thất bại, vui lòng thử lại!`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${infoBranch ? 'Cập nhật' : 'Tạo'} chi nhánh thất bại, vui lòng thử lại!`,
        })
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const _uploadImageParty = async (file) => {
    try {
      setLoadingImagesParty(true)
      const url = await uploadFile(file)
      setLoadingImagesParty(false)
      if (url) {
        imagesParty.push(url)
        setImagesParty([...imagesParty])
      }
    } catch (error) {
      setLoadingImagesParty(false)
      console.log(error)
    }
  }

  const handleDeleteImagePartys = async (url) => {
    try {
      if (url) {
        const imagesPartyNew = [...imagesParty]
        const imageIndex = imagesPartyNew.findIndex((img) => img === url)
        if (imageIndex !== -1) imagesPartyNew.splice(imageIndex, 1)
        setImagesParty([...imagesPartyNew])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const [initialImagesParty, setInitialImagesParty] = useState(infoBranch?.image_party || [])
  useEffect(() => {
    if (!visible) {
      form.resetFields();
      setImagesParty([...initialImagesParty]); // Khôi phục ảnh ban đầu khi modal đóng
    } else {
      if (infoBranch) {
        setImageBranch(infoBranch.image_url || '');
        setImagesParty(infoBranch.image_party || []);
        setInitialImagesParty(infoBranch.image_party || []); // Lưu ảnh ban đầu khi modal mở
        form.setFieldsValue({ ...infoBranch });
      }
    }
  }, [visible]);
  

  const onSearchAddress = (value) => {
    try {
      if (value) {
        if (typingTimeoutRef.current) {
          clearTimeout(typingTimeoutRef.current)
        }
        typingTimeoutRef.current = setTimeout(async () => {
          setLoadingAddress(true)
          setAddressList([])
          const res = await searchAddress({ address: removeAccents(value) })
          console.log(res)
          setLoadingAddress(false)
          if (res.status === 200) setAddressList(res.data.data)
        }, 650)
      }
    } catch (error) { }
  }


  const _getTimesSlot = async (query) => {
    try {
      let _timeSlots = TIME_SLOTS.filter((val) => val.disabled == false);
      setTimeSlots(_timeSlots);
    } catch (error) {
      console.log(error)
    }

    
  }

  const setTimeOpen = (val, index ) => {
    // console.log("setTimeOpen");
    // setText('');
    timeBlocks[index]= {
      open: val,
      close: timeBlocks[index].close
    };
    // if(index ==0) {
    //   setMondayOpen(val);
    // }
    setTimeBlocks(timeBlocks);
    // setText('hello');
    // console.log("setTimeOpen");
    switch(index) {
      case 0:
        setMonOpen(val);
        break;
      case 1:
        setTueOpen(val);
        break;
      case 2:
        setWedOpen(val);
        break;
      case 3:
        setThuOpen(val);
        break;
      case 4:
        setFriOpen(val);
        break;
      case 5:
        setSatOpen(val);
        break;
      case 6:
        setSunOpen(val);
        break;     
    }

  }

  const setTimeClose = (val,index ) => {
    // setText('');
    timeBlocks[index]= {
      open: timeBlocks[index].open,
      close: val
    };
    // // // setTimeBlocks(timeBlocks);
    // setText('hello');
    setTimeBlocks(timeBlocks);
    switch(index) {
      case 0:
        setMonClose(val);
        break;
      case 1:
        setTueClose(val);
        break;
      case 2:
        setWedClose(val);
        break;
      case 3:
        setThuClose(val);
        break;
      case 4:
        setFriClose(val);
        break;
      case 5:
        setSatClose(val);
        break;
      case 6:
        setSunClose(val);
        break;     
    }
  }

  const buildRowOpenAndClose = (index, valueOpen, valueClose) => {
    return <>
      <Row>
                  <div>{ buildTitle(index) }</div>
              </Row>
              <Row>
                  <Col md={10}>
                  <Select 
                     placeholder="Chọn thời gian mở" onChange={(val)=> {
                        setTimeOpen(val, index)
                      }} style={{ width: '100%' }}
                      value={valueOpen}
                      >
                      {timeSlots.map((timeSlot) => (
                        <Select.Option value={timeSlot.value} key={timeSlot.value + '_open_' + 0}>
                            {timeSlot.name}
                        </Select.Option>
                      ))}
                  </Select>
                  </Col>
                  <Col md={2} style={{textAlign:'center'}}>
                  ~
                  </Col>
                  <Col md={10}>
                  <Select name={('close' + 0)} placeholder="Chọn thời gian đóng" onChange={(val)=> {
                    setTimeClose(val, index)
                  }}
                      style={{ width: '100%' }}
                      value={valueClose}
                      >
                      {timeSlots.map((timeSlot) => (
                      <Select.Option value={timeSlot.value} key={timeSlot.value + '_close_' + 0}>
                          {timeSlot.name}
                      </Select.Option>
                      ))}
                  </Select>
                  </Col>
              </Row>
    </>;
  }

  useEffect(()=> {
    _getTimesSlot();
  }, [])

  const buildTitle = (index) => {
    return (index == 6 ? 'Chủ nhật' : 'Thứ ' + (Number(index)+2));
  }
  
  useEffect(() => {
    console.log("infoBranch", infoBranch);
    if (infoBranch && infoBranch.opening_data) {
      setTimeBlocks(infoBranch.opening_data);
      setMonOpen(infoBranch.opening_data[0].open);
      setMonClose(infoBranch.opening_data[0].close);

      setTueOpen(infoBranch.opening_data[1].open);
      setTueClose(infoBranch.opening_data[1].close);

      setWedOpen(infoBranch.opening_data[2].open);
      setWedClose(infoBranch.opening_data[2].close);

      setThuOpen(infoBranch.opening_data[3].open);
      setThuClose(infoBranch.opening_data[3].close);  
      
      setFriOpen(infoBranch.opening_data[4].open);
      setFriClose(infoBranch.opening_data[4].close);  

      setSatOpen(infoBranch.opening_data[5].open);
      setSatClose(infoBranch.opening_data[5].close);  

      setSunOpen(infoBranch.opening_data[6].open);
      setSunClose(infoBranch.opening_data[6].close); 
    }

    if (infoBranch) {
      console.log("infoBranch", infoBranch);
      setFilesDrink(infoBranch.filesDrink ?? []);
      setFilesFood(infoBranch.filesFood ?? []);
      setFilesWine(infoBranch.filesWine ?? []);
      setFilesNews(infoBranch.filesNews ?? []);
      setfilesFoodPicture(infoBranch.filesFoodPicture ?? []);

      if (infoBranch.filesFood && infoBranch.filesFood.length > 0) {
        setFilesFoodView([
          ...infoBranch.filesFood.map((file, index) => {
            const fileSplit = file.split('/')
            const nameFile = fileSplit[fileSplit.length - 1]
            return {
              uid: index,
              name: nameFile ? nameFile : 'file',
              status: 'done',
              url: file,
              thumbUrl: file,
            }
          }),
        ])
      }

      if (infoBranch.filesDrink && infoBranch.filesDrink.length > 0) {

        setFilesDrinkView([
          ...infoBranch.filesDrink.map((file, index) => {
            console.log("file", file);
            const fileSplit = file.split('/')
            const nameFile = fileSplit[fileSplit.length - 1]
            return {
              uid: index,
              name: nameFile ? nameFile : 'file',
              status: 'done',
              url: file,
              thumbUrl: file,
            }
          }),
        ])
      }

      if (infoBranch.filesWine && infoBranch.filesWine.length > 0) {

        setFilesWineView([
          ...infoBranch.filesWine.map((file, index) => {
            const fileSplit = file.split('/')
            const nameFile = fileSplit[fileSplit.length - 1]
            return {
              uid: index,
              name: nameFile ? nameFile : 'file',
              status: 'done',
              url: file,
              thumbUrl: file,
            }
          }),
        ])
      }

      if (infoBranch.filesNews && infoBranch.filesNews.length > 0) {
        setFilesNewsView([
          ...infoBranch.filesNews?.map((file, index) => {
            const fileSplit = file.split('/')
            const nameFile = fileSplit[fileSplit.length - 1]
            return {
              uid: index,
              name: nameFile ? nameFile : 'file',
              status: 'done',
              url: file,
              thumbUrl: file,
            }
          }),
        ])
      }

      if (infoBranch.filesFoodPicture && infoBranch.filesFoodPicture.length > 0) {
        setFilesFoodPictureView([
          ...infoBranch.filesFoodPicture?.map((file, index) => {
            const fileSplit = file.split('/')
            const nameFile = fileSplit[fileSplit.length - 1]
            return {
              uid: index,
              name: nameFile ? nameFile : 'file',
              status: 'done',
              url: file,
              thumbUrl: file,
            }
          }),
        ])
      }
    }
  }, [infoBranch])

  //reset
  useEffect(() => {
    console.log("reset");
    if (!visible) {
      form.resetFields()
      setFiles([])
      setFilesView([])
    } else {
      if (infoBranch) {
        form.setFieldsValue({ ...infoBranch })
        setFiles(infoBranch.image_urls || [])
        setImageReservation(
          infoBranch.images_reservation && infoBranch.images_reservation.length
            ? infoBranch.images_reservation[0]
            : ''
        )
        setFilesView(
          infoBranch.image_urls
            ? infoBranch.image_urls.map((file, index) => {
              const fileSplit = file.split('/')
              const nameFile = fileSplit[fileSplit.length - 1]
              return {
                uid: index,
                name: nameFile ? nameFile : 'file',
                status: 'done',
                url: file,
                thumbUrl: file,
              }
            })
            : []
        )
        setViewport({ latitude: infoBranch.latitude, longitude: infoBranch.longitude, zoom: 16 })
      }
    }
  }, [visible])
  
  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      {visible ? <Drawer
        title={infoBranch ? 'Cập nhật chi nhánh' : 'Thêm chi nhánh'}
        centered
        width="80%"
        footer={
          <Row justify="end">
            <Button size="large" type="primary" onClick={_addOrUpdateBranch}>
              {infoBranch ? 'Cập nhật' : 'Thêm'}
            </Button>
          </Row>
        }
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Row gutter={[30, 0]}>
            <Col md={12}>
              <Upload
                listType="picture"
                fileList={filesView}
                onRemove={(file) => {
                  const indexRemove = files.findIndex((url) => url === file)
                  if (indexRemove) {
                    const filesNew = [...files]
                    filesNew.splice(indexRemove, 1)
                    setFiles([...filesNew])
                    setFilesView([
                      ...filesNew.map((file, index) => {
                        const fileSplit = file.split('/')
                        const nameFile = fileSplit[fileSplit.length - 1]
                        return {
                          uid: index,
                          name: nameFile ? nameFile : 'file',
                          status: 'done',
                          url: file,
                          thumbUrl: file,
                        }
                      }),
                    ])
                  }
                }}
                data={async (file) => {
                  setLoadingFile(true)
                  const url = await uploadFile(file)
                  setLoadingFile(false)
                  const filesNew = [...files]
                  filesNew.push(url)
                  setFiles([...filesNew])
                  setFilesView([
                    ...filesNew.map((file, index) => {
                      const fileSplit = file.split('/')
                      const nameFile = fileSplit[fileSplit.length - 1]
                      return {
                        uid: index,
                        name: nameFile ? nameFile : 'file',
                        status: 'done',
                        url: file,
                        thumbUrl: file,
                      }
                    }),
                  ])
                }}
                onChange={(info) => {
                  if (info.file.status !== 'done') info.file.status = 'done'
                }}
              >
                <Button
                  loading={loadingFile}
                  style={{ width: 140 }}
                  size="large"
                  icon={<UploadOutlined />}
                >
                  Hình ảnh
                </Button>
              </Upload>
              <br />

              <div style={{ marginBottom: 15 }}>
                <Form.Item
                  rules={[{ required: true, message: 'Vui lòng nhập địa chỉ!' }]}
                  label="Địa chỉ"
                  name="address"
                >
                  <AutoComplete
                    notFoundContent={loadingAddress ? <Spin /> : null}
                    onSearch={(value) => onSearchAddress(value)}
                    allowClear
                    placeholder="Nhập địa chỉ"
                    size="large"
                  >
                    {addressList.map((address, index) => (
                      <AutoComplete.Option key={index} value={address.description}>
                        {address.description}
                      </AutoComplete.Option>
                    ))}
                  </AutoComplete>
                </Form.Item>

                {/* <Form.Item
                  rules={[{ required: true, message: 'Vui lòng nhập latitude!' }]}
                  initialValue={0}
                  label="Latitude"
                  name="latitude"
                >
                  <InputNumber
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập latitude"
                  />
                </Form.Item>
                <Form.Item
                  rules={[{ required: true, message: 'Vui lòng nhập longitude!' }]}
                  initialValue={0}
                  label="Longitude"
                  name="longitude"
                >
                  <InputNumber
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập longitude"
                  />
                </Form.Item> */}

                <Form.Item initialValue="" label="Ưu tiên hiển thị" name="priority">
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập số ưu tiên"
                  />
                </Form.Item>

                <Form.Item initialValue="" label="Link bản đồ" name="google_map_url">
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập link bản đồ"
                  />
                </Form.Item>

                <Form.Item
                  initialValue=""
                  label="Link điều hướng chỉ đường"
                  name="google_navigation_url"
                >
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập link điều hướng chỉ đường"
                  />
                </Form.Item>

                <Form.Item initialValue="" label="Đánh giá (số sao)" name="rating">
                  <InputNumber
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Số sao đánh giá"
                  />
                </Form.Item>
                <div style={{ marginBottom: 10 }}>
                  <div>Hình ảnh reservation</div>
                  <Upload
                    accept="image/*"
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    data={async (file) => {
                      setLoadingReservation(true)
                      const url = await uploadFile(file)
                      if (url) setImageReservation(url)
                      setLoadingReservation(false)
                    }}
                  >
                    {imageReservation ? (
                      <img
                        src={imageReservation}
                        alt="avatar"
                        style={{
                          width: '100%',
                        }}
                      />
                    ) : (
                      <div>
                        {loadingReservation ? <LoadingOutlined /> : <PlusOutlined />}
                        <div
                          style={{
                            marginTop: 8,
                          }}
                        >
                          Upload
                        </div>
                      </div>
                    )}
                  </Upload>
                </div>

                <Form.Item name="description_reservation" label="Mô tả reservation">
                  <Input.TextArea size="large" placeholder="Nhập mô tả reservation" rows={4} />
                </Form.Item>

                <Form.Item name="content_below_map" label="Nội dung bên dưới bản đồ">
                  <Input.TextArea size="large" placeholder="Nhập nội dung" rows={4} />
                </Form.Item>

                <Form.Item valuePropName="checked" name="is_ATF">
                  <Checkbox>ATF Location</Checkbox>
                </Form.Item>

                {/* <div style={{ marginTop: 4 }}>
                  <MapGL
                    {...viewport}
                    width="100%"
                    height="250px"
                    goongApiAccessToken={process.env.REACT_APP_GOOGLE_MAP_KEY}
                  >
                    <Marker latitude={viewport.latitude} longitude={viewport.longitude}>
                      <svg
                        style={{ width: 35, height: 35 }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        fill="red"
                      >
                        <path d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z" />
                      </svg>
                    </Marker>
                  </MapGL>
                </div> */}
              </div>
            </Col>
            <Col md={12}>
              <div>
                <Form.Item
                  name="name"
                  label="Tên chi nhánh"
                  rules={[{ required: true, message: 'Vui lòng nhập tên chi nhánh!' }]}
                >
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập tên chi nhánh"
                  />
                </Form.Item>
                <Form.Item initialValue="" name="region_id" label="Khu vực">
                  <Select
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Chọn khu vực"
                    showSearch
                    optionFilterProp="children"
                    filterOption={filterOptionSelect}
                  >
                    {regions.map((region, index) => (
                      <Select.Option value={region.region_id} key={index}>
                        {region.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="phone"
                  label="Số điện thoại"
                  rules={[{ required: true, message: 'Vui lòng nhập số điện thoại!' }]}
                >
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập số điện thoại"
                  />
                </Form.Item>

                <Form.Item
                  name="name_email"
                  label="Name Email"
                  rules={[{ required: true, message: 'Vui lòng nhập tên người gửi email!' }]}
                >
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập name email"
                  />
                </Form.Item>

                <Form.Item
                  name="email_login"
                  label="Tên đăng nhập Email"
                  rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập email!' }]}
                >
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập tên đăng nhập email"
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  label="Password Email"
                  rules={[{ required: true, message: 'Vui lòng nhập password email!' }]}
                >
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập password email"
                  />
                </Form.Item>

                <Form.Item
                  name="reply_to"
                  label="Reply To Email"
                  rules={[{ required: true, message: 'Vui lòng nhập reply to email!' }]}
                >
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập reply to email"
                  />
                </Form.Item>

                <Form.Item name="date_open" label="Giờ mở cửa">
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập giờ mở cửa"
                  />
                </Form.Item>
                <Form.Item name="date_close" label="Giờ đóng cửa">
                  <Input
                    allowClear
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Nhập giờ đóng cửa"
                  />
                </Form.Item>

                <Form.Item name="description" label="Mô tả">
                  <Input.TextArea size="large" placeholder="Nhập mô tả" rows={4} />
                </Form.Item>

                <Form.Item valuePropName="checked" name="is_ST">
                  <Checkbox>ST Location</Checkbox>
                </Form.Item>
              </div>
            </Col>
            <Col md={24}>
              <Row>
                <div>Thời gian mở/đóng cửa</div>
              </Row>
      
              {buildRowOpenAndClose(0, monOpen, monClose)}
              {buildRowOpenAndClose(1, tueOpen, tueClose)}
              {buildRowOpenAndClose(2, wedOpen, wedClose)}
              {buildRowOpenAndClose(3, thuOpen, thuClose)}
              {buildRowOpenAndClose(4, friOpen, friClose)}
              {buildRowOpenAndClose(5, satOpen, satClose)}
              {buildRowOpenAndClose(6, sunOpen, sunClose)}
          
            </Col>
            <Col md = {24}>
            <div>
            <div>Hình ảnh tiệc chi nhánh</div>
            <Upload.Dragger
              fileList={imagesParty.map((image, index) => ({
                uid: index,
                name: getFileName(image),
                status: 'done',
                url: image,
                thumbUrl: image,
              }))}
              listType="picture"
              onChange={(info) => {
                info.file.status = 'done'
              }}
              accept="image/*"
              name="file"
              multiple="true"
              data={(file) => _uploadImageParty(file)}
              onRemove={(file) => handleDeleteImagePartys(file?.url)}
            >
              <p className="ant-upload-drag-icon">
                {loadingImagesParty ? <Spin /> : <InboxOutlined />}
              </p>
              <p className="ant-upload-text">Nhấp hoặc kéo ảnh vào khu vực này để tải lên</p>
            </Upload.Dragger>
            </div>
            </Col>
            <Col md={24}>
              <Row>
                <Col style={{ flex: 1, padding: '5px' }}>
                  <Upload
                    accept="application/pdf"
                    listType="picture"
                    fileList={filesFoodView}
                    onRemove={(file) => {
                      const indexRemove = filesFood.findIndex((url) => url === file)
                      if (indexRemove) {
                        const filesNew = [...filesFood]
                        filesNew.splice(indexRemove, 1)
                        setFilesFood([...filesNew])
                        setFilesFoodView([
                          ...filesNew.map((file, index) => {
                            const fileSplit = file.split('/')
                            const nameFile = fileSplit[fileSplit.length - 1]
                            return {
                              uid: index,
                              name: nameFile ? nameFile : 'file',
                              status: 'done',
                              url: file,
                              thumbUrl: file,
                            }
                          }),
                        ])
                      }
                    }}
                    data={async (file) => {
                      setLoadingFile(true)
                      const url = await uploadFilePDF(file)
                      setLoadingFile(false)
                      const filesNew = [...filesFood]
                      filesNew.push(url)
                      setFilesFood([...filesNew])
                      setFilesFoodView([
                        ...filesNew.map((file, index) => {
                          const fileSplit = file.split('/')
                          const nameFile = fileSplit[fileSplit.length - 1]
                          return {
                            uid: index,
                            name: nameFile ? nameFile : 'file',
                            status: 'done',
                            url: file,
                            thumbUrl: file,
                          }
                        }),
                      ])
                    }}
                    onChange={(info) => {
                      if (info.file.status !== 'done') info.file.status = 'done'
                    }}
                  >
                    <Button
                      loading={loadingFile}
                      style={{ width: 180 }}
                      size="large"
                      icon={<UploadOutlined />}
                    >
                      File Menu Food
                    </Button>
                  </Upload>
                </Col>
                <Col style={{ flex: 1, padding: '5px' }}>
                  <Upload
                    accept="application/pdf"
                    listType="picture"
                    fileList={filesDrinkView}
                    onRemove={(file) => {
                      console.log(filesDrink);
                      const indexRemove = filesDrink.findIndex((url) => url === file)
                      if (indexRemove) {
                        const filesNew = [...filesDrink]
                        filesNew.splice(indexRemove, 1)
                        setFilesDrink([...filesNew])
                        setFilesDrinkView([
                          ...filesNew.map((file, index) => {
                            const fileSplit = file.split('/')
                            const nameFile = fileSplit[fileSplit.length - 1]
                            return {
                              uid: index,
                              name: nameFile ? nameFile : 'file',
                              status: 'done',
                              url: file,
                              thumbUrl: file,
                            }
                          }),
                        ])
                      }
                    }}
                    data={async (file) => {
                      setLoadingFile(true)
                      const url = await uploadFilePDF(file)
                      setLoadingFile(false)
                      console.log("filesDrink", filesDrink);
                      const filesNew = [...filesDrink]
                      filesNew.push(url)
                      setFilesDrink([...filesNew])
                      setFilesDrinkView([
                        ...filesNew.map((file, index) => {
                          const fileSplit = file.split('/')
                          const nameFile = fileSplit[fileSplit.length - 1]
                          return {
                            uid: index,
                            name: nameFile ? nameFile : 'file',
                            status: 'done',
                            url: file,
                            thumbUrl: file,
                          }
                        }),
                      ])
                    }}
                    onChange={(info) => {
                      if (info.file.status !== 'done') info.file.status = 'done'
                    }}
                  >
                    <Button
                      loading={loadingFile}
                      style={{ width: 180 }}
                      size="large"
                      icon={<UploadOutlined />}
                    >
                      File Menu Drink
                    </Button>
                  </Upload>
                </Col>
                <Col style={{ flex: 1, padding: '5px' }}>
                  <Upload
                    accept="application/pdf"
                    listType="picture"
                    fileList={filesWineView}
                    onRemove={(file) => {
                      const indexRemove = filesWine.findIndex((url) => url === file)
                      if (indexRemove) {
                        const filesNew = [...filesWine]
                        filesNew.splice(indexRemove, 1)
                        setFilesWine([...filesNew])
                        setFilesWineView([
                          ...filesNew.map((file, index) => {
                            const fileSplit = file.split('/')
                            const nameFile = fileSplit[fileSplit.length - 1]
                            return {
                              uid: index,
                              name: nameFile ? nameFile : 'file',
                              status: 'done',
                              url: file,
                              thumbUrl: file,
                            }
                          }),
                        ])
                      }
                    }}
                    data={async (file) => {
                      setLoadingFile(true)
                      const url = await uploadFilePDF(file)
                      setLoadingFile(false)
                      const filesNew = [...filesWine]
                      filesNew.push(url)
                      setFilesWine([...filesNew])
                      setFilesWineView([
                        ...filesNew.map((file, index) => {
                          const fileSplit = file.split('/')
                          const nameFile = fileSplit[fileSplit.length - 1]
                          return {
                            uid: index,
                            name: nameFile ? nameFile : 'file',
                            status: 'done',
                            url: file,
                            thumbUrl: file,
                          }
                        }),
                      ])
                    }}
                    onChange={(info) => {
                      if (info.file.status !== 'done') info.file.status = 'done'
                    }}

                  >
                    <Button
                      loading={loadingFile}
                      style={{ width: 180 }}
                      size="large"
                      icon={<UploadOutlined />}
                    >
                      File Menu Wine
                    </Button>
                  </Upload>
                </Col>
                <Col style={{ flex: 1, padding: '5px' }}>
                  <Upload
                    accept="application/pdf"
                    listType="picture"
                    fileList={filesNewsView}
                    onRemove={(file) => {
                      const indexRemove = filesNews.findIndex((url) => url === file)
                      if (indexRemove) {
                        const filesNew = [...filesNews]
                        filesNew.splice(indexRemove, 1)
                        setFilesNews([...filesNew])
                        setFilesNewsView([
                          ...filesNew.map((file, index) => {
                            const fileSplit = file.split('/')
                            const nameFile = fileSplit[fileSplit.length - 1]
                            return {
                              uid: index,
                              name: nameFile ? nameFile : 'file',
                              status: 'done',
                              url: file,
                              thumbUrl: file,
                            }
                          }),
                        ])
                      }
                    }}
                    data={async (file) => {
                      setLoadingFile(true)
                      const url = await uploadFilePDF(file)
                      setLoadingFile(false)
                      const filesNew = [...filesNews]
                      filesNew.push(url)
                      setFilesNews([...filesNew])
                      setFilesNewsView([
                        ...filesNew.map((file, index) => {
                          const fileSplit = file.split('/')
                          const nameFile = fileSplit[fileSplit.length - 1]
                          return {
                            uid: index,
                            name: nameFile ? nameFile : 'file',
                            status: 'done',
                            url: file,
                            thumbUrl: file,
                          }
                        }),
                      ])
                    }}
                    onChange={(info) => {
                      if (info.file.status !== 'done') info.file.status = 'done'
                    }}

                  >
                    <Button
                      loading={loadingFile}
                      style={{ width: 180 }}
                      size="large"
                      icon={<UploadOutlined />}
                    >
                      File Menu News
                    </Button>
                  </Upload>
                </Col>
                <Col style={{ flex: 1, padding: '5px' }}>
                  <Upload
                    accept="application/pdf"
                    listType="picture"
                    fileList={filesFoodPictureView}
                    onRemove={(file) => {
                      const indexRemove = filesFoodPicture.findIndex((url) => url === file)
                      if (indexRemove) {
                        const filesNew = [...filesFoodPicture]
                        filesNew.splice(indexRemove, 1)
                        setfilesFoodPicture([...filesNew])
                        setFilesFoodPictureView([
                          ...filesNew.map((file, index) => {
                            const fileSplit = file.split('/')
                            const nameFile = fileSplit[fileSplit.length - 1]
                            return {
                              uid: index,
                              name: nameFile ? nameFile : 'file',
                              status: 'done',
                              url: file,
                              thumbUrl: file,
                            }
                          }),
                        ])
                      }
                    }}
                    data={async (file) => {
                      setLoadingFile(true)
                      const url = await uploadFilePDF(file)
                      setLoadingFile(false)
                      const filesNew = [...filesFoodPicture]
                      filesNew.push(url)
                      setfilesFoodPicture([...filesNew])
                      setFilesFoodPictureView([
                        ...filesNew.map((file, index) => {
                          const fileSplit = file.split('/')
                          const nameFile = fileSplit[fileSplit.length - 1]
                          return {
                            uid: index,
                            name: nameFile ? nameFile : 'file',
                            status: 'done',
                            url: file,
                            thumbUrl: file,
                          }
                        }),
                      ])
                    }}
                    onChange={(info) => {
                      if (info.file.status !== 'done') info.file.status = 'done'
                    }}

                  >
                    <Button
                      loading={loadingFile}
                      style={{ width: 180 }}
                      size="large"
                      icon={<UploadOutlined />}
                    >
                      Food Picture Catalog
                    </Button>
                  </Upload>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={24}>

            </Col>
          </Row>
        </Form>
      </Drawer> : <></>}
    </>
  )
}


// function BranchForm({ reloadData, children, infoBranch, regions = [] }) {
// }

